export const GET_TASKS = "GET_TASKS";
export const ADD_TASKS = "ADD_TASKS";
export const UPDATE_TASKS = "UPDATE_TASKS";
export const REMOVE_TASKS = "REMOVE_TASKS";
export const GET_TASK1= "GET_TASK1"
export const GET_TASKSBYID ="GET_TASKSBYID"